import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-search-filter-date-range]';
const PLUGIN_NAME = 'searchFilterDateRange';

const log = debug('search/results-filter/search-filter-date:range');

class SearchFilterDateRange {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.form = this.selectors.selectTarget(
			'(parents) form',
			this.$element
		);

		this.allCheckbox = this.selectors.selectTarget(
			this.options.allCheckboxSelector,
			this.$element
		);

		this.dateComponents = this.selectors.selectTarget(
			this.options.dateComponentsSelector,
			this.$element
		);

		this.fromInput = this.selectors.selectTarget(
			this.options.fromInputSelector,
			this.$element
		);

		this.toInput = this.selectors.selectTarget(
			this.options.toInputSelector,
			this.$element
		);

		this.validationMessage = this.selectors.selectTarget(
			this.options.validationMessageSelector,
			this.$element
		);

		this.watch();

		log('ready', this);
	}

	watch() {
		log('watching');

		this.allCheckbox.on('change', this.onCheckboxChange.bind(this));

		this.form.on('submit', this.onSubmit.bind(this));

		//	'date-changed' event bubbled from child components
		this.$element.on('datechange', this.onDateChanged.bind(this));
	}

	isUnfiltered(from, to) {
		return !from && !to;
	}

	isFullDate(year) {
		return year.length === 4;
	}

	hasDateRange(fromDate, toDate) {
		return this.isFullDate(fromDate) && this.isFullDate(toDate);
	}

	isValidDateRange(from, to) {
		return from <= to;
	}

	onCheckboxChange() {
		if (this.allCheckbox.is(':checked')) {
			this.dateComponents.searchFilterYear('reset');
		}
	}

	shouldDisplayRangeError(fromValue, toValue) {

		if (!this.hasDateRange(fromValue, toValue)) {
			return false;
		}

		return !this.isValidDateRange(fromValue, toValue);
	}

	updateValidation(fromValue, toValue) {
		if (this.shouldDisplayRangeError(fromValue, toValue)) {
			this.validationMessage.removeAttr('hidden');
		} else {
			this.validationMessage.attr('hidden','hidden');
		}
	}

	onDateChanged() {
		const from = this.fromInput[0].value;
		const to = this.toInput[0].value;
		this.allCheckbox.prop('checked', this.isUnfiltered(from, to));
		this.updateValidation(from,to);
	}

	onSubmit(event) {
		const from = this.fromInput[0].value;
		const to = this.toInput[0].value;
		const isInvalid = this.shouldDisplayRangeError(from, to);

		this.updateValidation(from,to);

		if (isInvalid) {
			event.preventDefault();
		}
	}
}

SearchFilterDateRange.DEFAULTS = {};
plugin(PLUGIN_NAME, SearchFilterDateRange);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./project/client/src/site__vegkit/components/search/results-filter/search-filter-date-range.js